import {
  formSpecification as commonFormSpecification,
  type RecordPolicePresenceFormData as CommonRecordPolicePresenceFormData,
} from "../common/recordPolicePresence/officerRecordedResponseNo.js";

export const formSpecification = commonFormSpecification;

export type RecordPolicePresenceFormData = CommonRecordPolicePresenceFormData;
